/**
 * # Search Banner - Pick Banner Variation
 */
import { SearchBannerTextVariation } from '../TextVariations/index';

const PickBannerVariation = (arr: SearchBannerTextVariation[]) => {
    const pickedObj = arr[Math.floor(Math.random() * arr.length)];

    return pickedObj;
};

export default PickBannerVariation;
